import { APIResource, APIResponse, APIError } from "../utils/APIResource";
import config from "../config/config";

export default class EClaimServices {
  static fetchClaimant() {
    return APIResource.get("/v1/claim/claimant", {
      headers: {
        "x-auth-app": config.app.type
      }
    })
    .then(
      response => {
        return Promise.resolve(new APIResponse(response));
      },
      error => {
        return Promise.reject(new APIError(error));
      }
    );
  }

  static addClaim(data) {
    return APIResource.post("/v1/claim", data, {
      headers: {
        "x-auth-app": config.app.type
      }
    })
    .then(
      response => {
        return Promise.resolve(new APIResponse(response));
      },
      error => {
        return Promise.reject(new APIError(error));
      }
    );
  }

  static editClaim(id, data) {
    return APIResource.put(`/v1/claim/${id}`, data).then(
      response => {
        return Promise.resolve(new APIResponse(response));
      },
      error => {
        return Promise.reject(new APIError(error));
      }
    );
  }

  static fetchClaims() {
    let url = `/v1/claims`;
    return APIResource.get(url, {
      headers: {
        "x-auth-app": config.app.type
      }
    })
    .then(
      response => {
        return Promise.resolve(new APIResponse(response));
      },
      error => {
        return Promise.reject(new APIError(error));
      }
    );
  }

  static getClaim(claim_id) {
    return APIResource.get(`/v1/claim/${claim_id}`).then(
      response => {
        return Promise.resolve(new APIResponse(response));
      },
      error => {
        return Promise.reject(new APIError(error));
      }
    );
  }
}
